// 使用服务端时间；按北京时间日历归类，避免跨午夜和夏令时按24小时误算。
export function messageTime(value, now = Date.now()) {
  if (!value) return { label: '', full: '' }
  const date = new Date(new Date(value).getTime() + 8 * 3600000), today = new Date(new Date(now).getTime() + 8 * 3600000)
  if (!Number.isFinite(date.getTime()) || !Number.isFinite(today.getTime())) return { label: '', full: '' }
  const pad = n => String(n).padStart(2, '0')
  const clock = `${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}`
  const full = `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())} ${clock}`
  const day = d => Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate())
  const yesterday = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate() - 1))
  const monday = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate() - (today.getUTCDay() + 6) % 7))
  const label = day(date) === day(today) ? clock : day(date) === day(yesterday) ? `昨天 ${clock}`
    : day(date) >= day(monday) && day(date) < day(today) ? `周${'日一二三四五六'[date.getUTCDay()]} ${clock}` : full
  return { label, full }
}
